import { createContext, useContext } from 'react';

/** Si el formulario se abrió dentro de Gestión de clientes, esta función lo cierra y vuelve a la ficha. */
export const GestionCerrarContext = createContext<(() => void) | null>(null);

export function useCerrarGestion(): (() => void) | null {
  return useContext(GestionCerrarContext);
}
